import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "12"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "16",
  x2: "12.01",
  y2: "16"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.width,
    height: _ctx.heigth,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: _normalizeClass(["feather feather-alert-circle", [_ctx.color]])
  }, _hoisted_5, 10, _hoisted_1))
}